export default __webpack_public_path__ + "static/media/team-member-03.200cbdca.jpeg";